import { constants } from '../constant/constant';
import { httpservice } from '../services';
import { CRASH_LOG } from '../constant/actionTypes';
import { dateFormat, dateTimeFormat } from '../helper/StringUtils';

export const getCrashLogs = (obj) => (dispatch) => {
  const query = `${constants.API.GET_CRASH_LOGS}?page=${obj.page}&size=${obj.size}`;
  dispatch({
    payload: [],
    type: CRASH_LOG.DATA.INITIATE,
  });
  return httpservice()
    .get(query)
    .then((response) => {
      const rows = response.data.response.data.events;
      const count = response.data.response.data.totalItems;

      const responseData = rows.map((data) => (
        {
          ...data,
          createdAt: dateFormat(data.createdAt),
          reportDateTime: dateTimeFormat(data.reportDateTime),
          created_by: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'N/A',
          softwareName: data.software ? data.software.name : 'N/A',
          clientName: data.client ? data.client.name : 'N/A',
          hostName: (data.hostName !== '' && data.hostName != null) ? data.hostName : 'N/A',
          nickName: (data.nickName !== '' && data.nickName != null) ? data.nickName : 'N/A',
          ipAddress: (data.ipAddress !== '' && data.ipAddress != null) ? data.ipAddress : 'N/A',
        }
      ));

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: CRASH_LOG.DATA.SUCCESS,
      });
      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: CRASH_LOG.DATA.ERROR,
      });
    });
};

export const downloadCrashLogFile = (id, logFile) => httpservice('blob')
  .get(`${constants.API.DOWNLOAD_CRASH_LOG_FILE}/${id}`)
  .then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', logFile); // or any other extension
    document.body.appendChild(link);
    link.click();
    link.remove();
  })
  .catch((error) => (error.response && error.response.data ? error.response.data : error));
